import { ProductPackage } from './product-package';

/** Prefix of the record on an account's packages sync topic that carries the account default; no package id may start with it. */
export const ACCOUNT_DEFAULT_PRODUCT_PACKAGES_ID_PREFIX = 'account-default';

/** Id of an account's default record; unique per account, since clients store one record per id across accounts. */
export function accountDefaultProductPackagesId(accountId: string): string {
    return `${ACCOUNT_DEFAULT_PRODUCT_PACKAGES_ID_PREFIX}-${accountId}`;
}

/** The account's default packages as synced; absent or empty `packages` means every site without its own uses Core. */
export interface AccountDefaultProductPackages {
    id: string;
    packages?: string[];
}

/** A record on `account/{accountId}/sync/packages`: a package definition the account can use, or its account default. */
export type SyncProductPackageRecord = ProductPackage | AccountDefaultProductPackages;

/** True for the account default record, false for a package definition. */
export function isAccountDefaultProductPackages(record: Pick<SyncProductPackageRecord, 'id'>): record is AccountDefaultProductPackages {
    return record.id.startsWith(ACCOUNT_DEFAULT_PRODUCT_PACKAGES_ID_PREFIX);
}

/** The packages sync topic of one account. */
export function productPackagesSyncTopic(accountId: string): string {
    return `account/${accountId}/sync/packages`;
}
